var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6912 15.5488L6.29719 12.6147C5.6294 13.2758 4.70975 13.6842 3.69444 13.6842C1.65406 13.6842 0 12.0347 0 10C0 7.96526 1.65406 6.31579 3.69444 6.31579C4.70969 6.31579 5.62929 6.72417 6.29706 7.38519L11.6912 4.45111C11.6388 4.20373 11.6111 3.94719 11.6111 3.68421C11.6111 1.64947 13.2652 0 15.3056 0C17.3459 0 19 1.64947 19 3.68421C19 5.71895 17.3459 7.36842 15.3056 7.36842C14.2902 7.36842 13.3706 6.96001 12.7029 6.29894L7.30871 9.23295C7.36125 9.48042 7.38889 9.73695 7.38889 10C7.38889 10.2629 7.36127 10.5195 7.30875 10.7668L12.7029 13.7011C13.3707 13.04 14.2903 12.6316 15.3056 12.6316C17.3459 12.6316 19 14.2811 19 16.3158C19 18.3505 17.3459 20 15.3056 20C13.2652 20 11.6111 18.3505 11.6111 16.3158C11.6111 16.0528 11.6388 15.7962 11.6912 15.5488Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.8a19c14f90a34dbe34d0ae94ac46e6ee.svg";
export { ForwardRef as ReactComponent };